import {EdgeType} from '@PosterWhiteboard/classes/item-effects.class';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';

export enum PosterEditorItemEffects {
  EDGE_EFFECTS = 'EDGE_EFFECTS',
  REMOVE_COLOR = 'REMOVE_COLOR',
  GLOW = 'GLOW',
  SHADOW = 'SHADOW',
  BORDER = 'BORDER',
}

export interface PosterEditorItemEffectsData {
  effect: PosterEditorItemEffects;
  thumbnail: string;
}

export const POSTER_EDITOR_ITEM_EFFECTS_DATA_ARRAY: PosterEditorItemEffectsData[] = [
  {
    effect: PosterEditorItemEffects.EDGE_EFFECTS,
    thumbnail: 'edges',
  },
  {
    effect: PosterEditorItemEffects.REMOVE_COLOR,
    thumbnail: 'remove_color',
  },
  {
    effect: PosterEditorItemEffects.GLOW,
    thumbnail: 'glow',
  },
  {
    effect: PosterEditorItemEffects.SHADOW,
    thumbnail: 'shadow',
  },
  {
    effect: PosterEditorItemEffects.BORDER,
    thumbnail: 'border',
  },
];

export const getEdgeEffectNamefromEdgeEffectType = (valueType: EdgeType): string => {
  switch (valueType) {
    case EdgeType.NONE:
      return 'None';
    case EdgeType.OVAL:
      return 'Oval';
    case EdgeType.RECTANGLE:
      return 'Rectangle';
    case EdgeType.GRADIENT:
      return 'Gradient';
    case EdgeType.CURVED:
      return 'Curved';
    case EdgeType.SCRATCHED:
      return 'Scratched';
    case EdgeType.TORN_PAPER:
      return 'Torn Paper';
    case EdgeType.CIRCULAR:
      return 'Circular';
    case EdgeType.HEART:
    default:
      return 'Heart';
  }
};

export const getBorderNameFromType = (type: BorderType): string => {
  switch (type) {
    case BorderType.STROKE_BORDER:
      return 'Outline';
    case BorderType.ROUNDED_BORDER:
      return 'Rounded';
    case BorderType.RECTANGLE_BORDER:
      return 'Rectangle';
    case BorderType.NONE:
    default:
      return 'None';
  }
};
